
export const BASE_NAME = '/refi/auto';

export enum Permissions {
  ADMIN = 'Admin',
  PULLMSRP = 'Pull MSRP',
  EDITDOCFEE = 'Edit DocFee',
  SUBPRIME = 'Subprime',
}

export enum Roles {
  EDIT_BOOKOUT = 'Edit Bookout',
  PULL_FINAL_PAYOFF = 'Pull Final Payoff',
  ACUMATICA_AT_SUBMIT = 'Acumatica & AT Submit',
  ADMIN = 'Admin',
  LC = 'LC',
  LCA = 'LCA',
  LC_LEAD = 'LC Lead',
  LC_MANAGER = 'LC Manager',
  LP = 'LP',
  EDIT_CUDL_APPROVAL_FIELDS = 'Edit CUDL Approval Fields',
  SDR = 'SDR',
  SDR_DEAL_USER = 'SDR Deal User',
  EDITDOCFEE = 'Edit DocFee',
  DEAL_USER_ASSIGNMENT = 'DealUserAssignment',
  CREDIT_CARD_PROCESSING = 'Credit Card Processing',
  DEAL_CALC_OVERRIDE = 'Override Deal Calc',
  PULLMSRP = 'Pull MSRP',
  EDIT_PRODUCT_PRICE = 'Edit Product Price',
  ACCOUNING = 'Accounting',
  CUSTOMER_SERVICE = 'Customer Service',
  CREDIT_REPORTS_PULL_ALL = 'CreditReports_PullAll',
  CREDIT_REPORTS_PULL_EXPERIAN = 'CreditReports_PullExperian',
  CREDIT_REPORTS_PULL_TRANSUNION = 'CreditReports_PullTransUnion',
  CREDIT_REPORTS_PULL_EQUIFAX = 'CreditReports_PullEquifax',
  CREDIT_REPORTS_PULL_EXPERIANFICO = 'CreditReports_PullExperianFico',
  CREDIT_REPORTS_VIEW_ALL = 'CreditReports_ViewAll',
  EDIT_MLA_FLAG = 'Edit MLA Flag',
  EDIT_OCP_FLAG = 'Edit OCP Flag',
  LIEN_HOLDER_EDIT = 'Lien Holder Edit',
  PULL_REGISTRATION = 'Pull Registration',
  DOC_GEN_TITLE = 'DocGenTitles',
  DOC_GEN_LENDER = 'DocGenLender',
  GOAL_ENTRY_OVERRIDE = 'GoalEntryOverride',
  ROUND_ROBIN_LOAN_PROCESSING = 'Round Robin - Loan Processing',
  ROUND_ROBIN_SDR = 'Round Robin - SDR',
  BANK = 'Bank',
  BANK_MANAGER ='Bank Manager',
  TITLES = 'Titles',
  TITLES_ADMIN = 'Titles Admin',
  OPENLENDINGCERTIFICATE = 'Open Lending Certificate',
  PUSH_CUNJ = 'Push CUNJ',
  EDIT_PLATE_2_VIN = 'EditPlate2VIN',
  LP_Lead = 'LP Lead',
  LP_Manager = 'LP Manager'
}

export const DEFAULT_ROUTES_BY_ROLES: { [key in Roles]?: string } = {
  [Roles.ADMIN]: 'AdminToolsMain',
  [Roles.LC]: 'Reminders',
  [Roles.LP]: 'LPQueuesMain',
  [Roles.ACCOUNING]: 'AccountingMain',
  [Roles.BANK]: 'BankTeamMain',
  [Roles.TITLES]: 'TitlesMain',
  [Roles.TITLES_ADMIN]: 'StateRequirements'
};

export const ROLES_PRIORITY = {
  [Roles.ADMIN]: 1,
  [Roles.LC]: 2,
  [Roles.LP]: 3,
  [Roles.TITLES]: 4,
  [Roles.TITLES_ADMIN]: 5,
  [Roles.ACCOUNING]: 6,
  [Roles.BANK]: 7,
};

export enum ContactManagerTabs {
  CONTACTS,
  ASSETS,
  LEADS,
  DEALS,
}

export const CARD_DIGIT_LENGTH = 16;
export const CVV_LENGTH = 3;
export const AMERICAN_EXPRESS_CREDIT_CARD_DIGIT_LENGTH = 15;
export const AMERICAN_EXPRESS_CREDIT_CARD_CVV_LENGTH = 4;

export const EXCEL_EXTENSIONS = ['.csv', '.xlsx', '.xls', '.ods'];

export enum CONFIRMATION_RESULT {
  CANCEL = 0,
  YES = 1,
  PENDING = 2,
}

export const STIP_TYPE_REGISTRATION = 'Registration';
export const STIP_TYPE_ADD123_CARFAX = 'Add123 History (CarFAX)';

export const OneToOneConsentPresentedAndAccepted = {
  No: 'No',
  Yes: 'Yes',
  NotAvailable: 'NotAvailable',
};

